import { render, staticRenderFns } from "./positioningRewardDetails.vue?vue&type=template&id=38e548b9&scoped=true&"
import script from "./positioningRewardDetails.vue?vue&type=script&lang=js&"
export * from "./positioningRewardDetails.vue?vue&type=script&lang=js&"
import style0 from "./positioningRewardDetails.vue?vue&type=style&index=0&id=38e548b9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e548b9",
  null
  
)

export default component.exports